export default import.meta.ROLLDOWN_FILE_URL_MiCl7ydeXBtmiYFVmUSlEA